/**
 * "Tələb olunan sənədlər" bölməsinin yüklənməsi və kopyalanması.
 *
 * Siyahı brauzerin çap dialoqu vasitəsilə verilir, çünki temada PDF kitabxanası
 * yoxdur və Azərbaycan əlifbasının hərfləri (ə, ğ, ı, ö, ş, ü) müştəri tərəfli
 * PDF generatorlarında şrift yüklənmədən pozulur. Çap dialoqunda müasir
 * brauzerlərin standart hədəfi "PDF kimi saxla"dır, yəni istifadəçi həqiqi PDF
 * fayl alır və nəticə brend şriftləri ilə düzgün görünür.
 */

const RESET_DELAY = 2200;

// Bu sinif çapda səhifənin qalan hissəsini kəsir. Yalnız düymə basılanda qoyulur ki,
// Ctrl+P ilə adi çap zamanı ölkə səhifəsi bütöv çıxsın.
const PRINT_MODE_CLASS = 'is-printing-documents';

/** Siyahını mesajlaşma tətbiqlərində oxunaqlı görünən mətnə çevirir. */
function buildPlainText(section, title) {
  const lines = [];

  if (title) {
    lines.push(title, '');
  }

  section.querySelectorAll('.destination-documents__item').forEach((item, index) => {
    const name = item.querySelector('strong');
    const note = item.querySelector('span');

    if (!name) {
      return;
    }

    lines.push(`${index + 1}. ${name.textContent.trim()}`);

    if (note && note.textContent.trim()) {
      lines.push(`   ${note.textContent.trim()}`);
    }
  });

  lines.push('', window.location.href);

  return lines.join('\n');
}

/** Clipboard API bloklananda (köhnə brauzer, HTTP) ehtiyat üsul. */
function legacyCopy(text) {
  const helper = document.createElement('textarea');

  helper.value = text;
  helper.setAttribute('readonly', '');
  helper.style.position = 'fixed';
  helper.style.top = '-1000px';
  document.body.appendChild(helper);
  helper.select();

  let copied = false;

  try {
    copied = document.execCommand('copy');
  } catch (error) {
    copied = false;
  }

  document.body.removeChild(helper);

  return copied;
}

export default function initDestinationDocuments() {
  const section = document.querySelector('.destination-documents');

  if (!section) {
    return;
  }

  const stamp = section.querySelector('[data-documents-date]');
  const downloadButton = section.querySelector('[data-documents-download]');
  const copyButton = section.querySelector('[data-documents-copy]');

  if (downloadButton) {
    const root = document.documentElement;
    let modeTimer = null;

    const leavePrintMode = () => {
      window.clearTimeout(modeTimer);
      root.classList.remove(PRINT_MODE_CLASS);
    };

    // Dialoq bağlananda sinif götürülür. Safari `afterprint`-i həmişə göndərmir,
    // ona görə vaxt əsaslı ehtiyat da qoyulub — sinif səhifədə ilişib qalmasın.
    window.addEventListener('afterprint', leavePrintMode);

    downloadButton.addEventListener('click', () => {
      // Çap tarixi yalnız çap anında yazılır ki, keşlənmiş səhifədə köhnə tarix qalmasın.
      if (stamp) {
        stamp.textContent = new Date().toLocaleDateString('az-AZ', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      }

      root.classList.add(PRINT_MODE_CLASS);

      window.clearTimeout(modeTimer);
      modeTimer = window.setTimeout(leavePrintMode, 60000);

      window.print();
    });
  }

  if (!copyButton) {
    return;
  }

  const label = copyButton.querySelector('[data-copy-label]');
  const originalLabel = label ? label.textContent : '';
  let resetTimer = null;

  const showResult = (message) => {
    if (!label) {
      return;
    }

    label.textContent = message;
    copyButton.classList.add('is-copied');
    window.clearTimeout(resetTimer);

    resetTimer = window.setTimeout(() => {
      label.textContent = originalLabel;
      copyButton.classList.remove('is-copied');
    }, RESET_DELAY);
  };

  copyButton.addEventListener('click', async () => {
    const text = buildPlainText(section, copyButton.dataset.copyTitle || '');

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        showResult(copyButton.dataset.copiedText || 'Kopyalandı');

        return;
      } catch (error) {
        // Aşağıdakı ehtiyat üsula keçilir.
      }
    }

    showResult(
      legacyCopy(text)
        ? copyButton.dataset.copiedText || 'Kopyalandı'
        : copyButton.dataset.errorText || 'Kopyalamaq alınmadı'
    );
  });
}
